import React from 'react';
import PropTypes from 'prop-types';
import styles from './Toggle.styles.js';
import ToggleButton from 'react-toggle-button';

class Toggle extends React.Component {
  constructor(props) {
    super(props);

    this.state ={
      focus: false,
    };
  }

  render() {
    let {
      disabled,
      inactiveTrackColor,
      includeLabels,
      onToggle,
      passThroughInputProps,
      value,
    } = this.props;
    let {
      focus,
    } = this.state;

    return (
      <span
        onBlur={() => this.setState({focus: false})}
        onFocus={() => this.setState({focus: true})}
      >
        <ToggleButton
          activeLabel={includeLabels ? 'On' : null}
          activeLabelStyle={styles.activeLabelStyle}
          colors={{
            activeThumb: styles.colors.activeThumb.calculate({
              disabled,
            }),
            inactiveThumb: styles.colors.inactiveThumb.calculate({
              disabled,
            }),
            active: styles.colors.active.calculate({
              disabled,
              focus,
            }),
            inactive: styles.colors.inactive.calculate({
              disabled,
              focus,
              inactiveTrackColor,
            }),
          }}
          containerStyle={styles.container.calculate({
            disabled,
            usingLabels: includeLabels,
          })}
          inactiveLabel={includeLabels ? 'Off' : null}
          inactiveLabelStyle={styles.inactiveLabelStyle.calculate({
            disabled,
            focus,
          })}
          inactiveLabelStyleHover={styles.inactiveLabelStyleHover.calculate({
            disabled,
          })}
          onToggle={(val) => onToggle(!val)}
          passThroughInputProps={{
            ...passThroughInputProps,
            disabled
          }}
          thumbAnimateRange={includeLabels ? [0, 42] : [0, 29]}
          thumbIcon={
            disabled &&
              <div
                style={styles.disabledThumbIcon}
              >|</div>
          }
          thumbStyle={styles.thumb.calculate({
            active: value,
            disabled,
            focus,
          })}
          thumbStyleHover={styles.thumb.hover.calculate({
            active: value,
            disabled,
          })}
          trackStyle={styles.track.calculate({
            active: value,
            disabled,
            focus,
            usingLabels: includeLabels,
          })}
          trackStyleHover={styles.track.hover.calculate({
            active: value,
            disabled,
          })}
          value={value}
        />
      </span>
    );
  }
}

Toggle.propTypes = {
  disabled: PropTypes.bool,
  inactiveTrackColor: PropTypes.oneOf(['#FFFFFF', '#EEEEEE']),
  includeLabels: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  passThroughInputProps: PropTypes.object,
  value: PropTypes.bool.isRequired,
};

Toggle.defaultProps = {
  inactiveTrackColor: '#FFFFFF',
  onToggle: () => {},
};

export default Toggle;